<template>
  <div>
    <app-banner title="Web Affiliate ID &amp; Custom Link" />
    <section class="content-wrapper">
      <div class="content">
        <label for="affiliate-id">Your web affiliate ID #</label>
        <span class="p4">
          If you don't have an ID number, contact
          <a href="mailto:info@pilates.com">info@pilates.com</a>.
        </span>
        <input
          type="text"
          v-model="id"
          id="affiliate-id"
          placeholder="e.g. 1234456"
        />
        <label for="page-url">Pilates.com page URL</label>
        <span class="p4">
          Link to our store home page, or to a specific category or product
          page.
        </span>
        <input
          type="text"
          v-model="url"
          id="page-url"
          placeholder="example: www.pilates.com/store/"
        />
        <button class="btn" @click="nextPage">Next</button>
        <p v-if="validated" class="alert">
          Both fields require a value to continue
        </p>
        <a class="link" @click="prevPage">‹ Back</a>
      </div>
      <img
        :src="`${$assets}img-affiliate-2@1x.jpg`"
        :srcset="`${$assets}img-affiliate-2@2x.jpg 2x`"
        alt="Group mat class with Ultra-Fit Circle"
        class="wide photo"
      />
    </section>
  </div>
</template>

<script>
import AppBanner from "@/components/AppBanner.vue";

export default {
  name: "StepTwo",

  components: {
    AppBanner
  },

  data() {
    return {
      id: "",
      url: "",
      validated: ""
    };
  },

  methods: {
    nextPage() {
      if (this.id && this.url) {
        this.validate = "";
        this.$bus.$emit("id", this.id);
        this.$bus.$emit("url", this.url);
        this.$emit("clicked", "three");
      } else {
        this.validated = true;
      }
    },

    prevPage() {
      this.$emit("clicked", "one");
    }
  }
};
</script>

<style scoped>
.content-wrapper {
  display: flex;
}

.content {
  padding: 50px 32px;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
}

label {
  font-family: var(--roboto);
  font-weight: 700;
  font-size: 12rem;
  line-height: 1.167;
  text-transform: uppercase;
  color: var(--text-gray);
  display: block;
}

.p4 {
  color: #919191;
  margin-bottom: 5px;
  display: block;
}

.p4 a {
  color: #919191;
}

.p4 a:hover {
  color: #000000;
}

input {
  border: 1px solid #919191;
  width: 100%;
  max-width: 360px;
  height: 44px;
  padding: 0 10px;
  margin-bottom: 40px;
  display: block;
}

input::placeholder {
  color: #919191;
}

input:focus {
  outline: none;
  border: 3px solid var(--green);
}

.btn {
  background-color: var(--green);
  color: var(--white);
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14rem;
  line-height: 1.143;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 165px;
  height: 30px;
  transition: 0.3s;
  margin-bottom: 20px;
}

.btn:hover {
  background-color: var(--dk-green);
}

.link {
  font-family: var(--roboto);
  font-size: 14rem;
  line-height: 1.143;
  font-weight: 500;
  color: var(--emerald);
  text-decoration: none;
  margin-top: auto;
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
}

.photo {
  width: 41%;
  max-width: 472px;
  object-fit: cover;
  flex: 0 0 auto;
  margin-left: auto;
}

.alert {
  margin-bottom: 20px;
  font-size: 12rem;
}

@media (min-width: 768px) {
  .content {
    padding: 70px 5%;
    width: 59%;
  }
}
</style>
